// farm-booking/frontend/src/hooks/useMaintenanceMode.js
// Hook pour détecter le mode maintenance
// 73+ Papy

import { useState, useEffect } from 'react'

export function useMaintenanceMode() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/settings')
      .then(res => res.json())
      .then(data => {
        setIsMaintenanceMode(data?.etat_site === 'maintenance')
        setLoading(false)
      })
      .catch(err => {
        console.error('Erreur chargement settings:', err)
        setLoading(false)
      })
  }, [])

  return { isMaintenanceMode, loading }
}
